export const ignoreLoader = {
    apis: [
        '/cms/media/',
        '/upload/media'
    ]
};